import {MultiTargetRelation} from '../MultiTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchCircleObject} from '../../../../../mesh/sketch';

let count = 0;

/**
 * 圆-相等关系约束。
 */
export function isCircleEqualConstraint(value: object): value is CircleEqualConstraint {
    return Reflect.get(value, "isCircleEqualConstraint") === true;
}
export class CircleEqualConstraint extends MultiTargetRelation<SketchCircleObject> {
    readonly isCircleEqualConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.Equal;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '相等';
    }

}
